import styled from "@mui/material/styles/styled";
import { PatientColorMap } from "../../../layout/patientColorMap";
import { SIDE_PADDING } from "../../consts/sizeConsts";
import { onRtl } from "fe-web-components/rtl/rtlStyles";

export const QuestionOptionsContainer = styled("div")(
  ({ darkbg }: { darkbg?: string }) => ({
    backgroundColor:
      darkbg === "true"
        ? PatientColorMap.GradDark
        : PatientColorMap.Background2,
    marginRight: `-${SIDE_PADDING}px`,
    marginLeft: `-${SIDE_PADDING}px`,
    paddingLeft: `${SIDE_PADDING}px`,
    paddingRight: `${SIDE_PADDING}px`,
    "&.three-way": {
      paddingRight: "6px",
      paddingLeft: "6px",
    },
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    ...onRtl({
      marginLeft: `-${SIDE_PADDING}px`,
      marginRight: `-${SIDE_PADDING}px`,
      paddingRight: `${SIDE_PADDING}px`,
      paddingLeft: `${SIDE_PADDING}px`,
      "&.three-way": {
        paddingRight: "6px",
        paddingLeft: "6px",
      },
    }),
    width: `calc(100% + ${2 * SIDE_PADDING})`,
    boxSizing: "content-box",
    paddingTop: "15px",
    paddingBottom: "15px",
    marginTop: "10px",
    "& .patient-MuiChip-root[selectedvalue='false'] span.patient-MuiChip-label": {
      color: PatientColorMap.Default,
    },
    "& .patient-MuiChip-root[selectedvalue='true'] span.patient-MuiChip-label": {
      color: PatientColorMap.White,
    },
    "& img": {
      width: "35px",
      height: "35px",
    },
  }),
);

export const OptionsWrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  maxWidth: "380px",
});
